import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=72100f78"
import script from "./paperDetail.vue?vue&type=script&lang=js"
export * from "./paperDetail.vue?vue&type=script&lang=js"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=72100f78&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports